// import Modal from "react-responsive-modal";
import { lazy } from 'react';
import Modal from 'react-modal'
// const VariationSelection=lazy(()=>import( "../MenuSelection/VariationSelection"))
import VariationSelection from '../MenuSelection/VariationSelection';
// refrencePage_variation_modal
import { refPageModal } from "../../constant/constant";

interface customeType {
  open: boolean;
  onCloseModal: any;
  taxdata: any;
  menu_id: any;
}
const VariationModal = ({ open, onCloseModal, menu_id, taxdata, }: customeType) => {

  // className="new-modal-react w-auto bg-white p-0 md:h-[35rem] md:!rounded-md !rounded-none  overflow-hidden"
  //           onRequestClose={handleModalClose}
  //           isOpen={open}


  return (
    <Modal
      className="new-modal-react w-auto bg-white p-0 md:h-[35rem] md:!rounded-md !rounded-none  overflow-hidden"
      onRequestClose={onCloseModal}
      isOpen={open}
      closeTimeoutMS={300}
      overlayClassName="modal-overlay"

    // open={open}
    // onClose={onCloseModal}
    // center
    // classNames={{
    //   overlay: "customOverlay",
    //   modal: "customModal", // removed scroll-hidden
    //   closeIcon: "modal-close",
    // }}
    >
      <button className="new-close-btn" onClick={onCloseModal}>
        <svg className="modal-close" width="28" height="28" viewBox="0 0 36 36" data-testid="close-icon"><path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path></svg>
    
      </button>

      {/* <div className='scroll-hidden' style={{ maxHeight: "90vh", overflowY: "auto" }}> */}
      <VariationSelection
        onCloseModal={onCloseModal}
        menu_id={menu_id}
        taxdata={taxdata}
        refrencePage={refPageModal}
      />
      {/* </div> */}
    </Modal>
  );
};

export default VariationModal;
